import React from "react";

const Buttons = ({ text, px, bg, border, color }) => {
  return (
    <button className={` ${bg} ${border} ${color} py-[1rem] rounded-md ${px}`}>
      {text}
    </button>
  );
};

export default Buttons;
